import mediaQuery from '@/lib/styling/mediaQuery';
import styled from '@emotion/styled';

type PreviewDialogImageWrapperProps = {
  enforceImageMinSize: boolean;
};

const PreviewDialogImageWrapper = styled('div')<PreviewDialogImageWrapperProps>(
  ({ enforceImageMinSize }) => ({
    position: 'relative',
    display: 'flex',
    img: {
      minWidth: enforceImageMinSize ? 400 : undefined,
    },
    [mediaQuery(424)]: {
      img: {
        minWidth: '100%',
      },
    },
  }),
);

export default PreviewDialogImageWrapper;
